export default __webpack_public_path__ + "static/media/11_wpp.7b2f706d.png";